import { render, staticRenderFns } from "./DeleteContact.vue?vue&type=template&id=2bf39c86&"
import script from "./DeleteContact.vue?vue&type=script&lang=js&"
export * from "./DeleteContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports